import { useTheme } from "../../theme/ThemeContext";

export default function ThemeToggle() {
  useTheme();
  return null;
}
